import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { LatLngLiteral, AgmMap } from '@agm/core';

export interface MapLocation {
    lat?: number;
    lng?: number;
}

@Component({
    selector: 'app-map-picker',
    templateUrl: './map-picker.component.html',
    styleUrls: ['./map-picker.component.css']
})
export class MapPickerComponent implements OnInit {
    @ViewChild(AgmMap, {static: true}) map: AgmMap;
    readonly mapTypeId = 'hybrid';

    @Input()
    height: string = 'calc(100vh - 330px)';

    get location(): MapLocation {
        return this._location;
    }

    @Input()
    set location(value: MapLocation) {
        if (value && !value.lng && !value.lng) value = null;
        this._location = value;
    }

    private _location: MapLocation;

    @Input()
    mapView: MapLocation;

    @Input()
    zoomLevel = 1;
    @Output()
    locationChange = new EventEmitter<MapLocation>();

    constructor() {
    }

    ngOnInit() {
    }

    setLocation(coords: LatLngLiteral) {
        this._location = coords;
        this.locationChange.emit(this._location);
    }
}
